export default __webpack_public_path__ + "ed76493eb8bbfbfe1ead6f30d15b8797.webp";